import { LoaderFunctionArgs } from "react-router";
import { handleApiFetch } from "../../utils";

export async function articleViewLoader({ params, context: loaderContext }: LoaderFunctionArgs<any>) {
    let context = loaderContext;
    if (typeof window !== "undefined" && window.__client_context) {
        context = window.__client_context
    }

    if (context == null) return {}

    const { ["*"]: path } = params;
    const response = await handleApiFetch(
        context.env,
        `/wiki/articles?path=${path}`,
        null,
        context['info']
    )

    return {
        article: response
    }
}